import { getAxiosHeader } from "mfe-common-common-utils-lib";
import _ from 'lodash'

globalThis.lodash = _;

const getLoginContext = () => {
  let loginContext = {};
  // try {
  //   loginContext = JSON.parse(sessionStorage.getItem('LoginContext'));
  // } catch (e) { }
  // return loginContext || {};
  try {
    loginContext = JSON.parse(sessionStorage.getItem('LoginContext'));
  } catch (e) {}

  const xAccOp = getAxiosHeader()["x-acc-op"];
  const xRefOp = getAxiosHeader()["x-ref-op"];
  const localCode = window.sessionStorage.getItem('localeCode');
  if(xAccOp && xRefOp){
    loginContext = {
      x_acc_op: xAccOp,
      x_ref_op: xRefOp,
      localeCode: localCode,
      loginTime: new Date().toLocaleString()
    }
  }

  return loginContext  || {};
}

const setLoginContext = (loginContext) => {
  sessionStorage.setItem('LoginContext', loginContext);
}

const getAccessToken = () => {
  return getLoginContext()["x_acc_op"];
}

const getRefreshToken = () => {
  return getLoginContext()["x_ref_op"];
}

const isLogin = () => {
  const accessToken = getAccessToken();
  return accessToken ? accessToken.length > 0 : false;
}

const isIFrame = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export { getLoginContext, setLoginContext, getAccessToken, getRefreshToken, isLogin, isIFrame };